import type { ContainerModuleLoader } from '@wix/thunderbolt-ioc'
import { ReactTemplateSymbol, ESMLoaderFactorySymbol, PromiseCacheSymbol, ImportMapSymbol } from './symbols'
import { ReactTemplateFactory } from './reactTemplateFactory'
import { ESMLoaderFactoryFactory } from './esmLoaderFactory'
import { PromiseCache } from './promiseCache'
import { ImportMapFactory } from './importMapFactory'

export const site: ContainerModuleLoader = (bind) => {
	bind(ReactTemplateSymbol).to(ReactTemplateFactory)
	bind(PromiseCacheSymbol).to(PromiseCache)
	bind(ImportMapSymbol).to(ImportMapFactory)
	bind(ESMLoaderFactorySymbol).to(ESMLoaderFactoryFactory)
}

export const editor: ContainerModuleLoader = site

// Export symbols and types for use by other features
export { ESMLoaderFactorySymbol, ImportMapSymbol } from './symbols'
export type { ESMLoaderFactory, ImportMap } from './types'
